var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { omit } from 'lodash';
export var generateFbeLoginUrl = function (queryParams) {
    var queryString = new URLSearchParams(queryParams).toString();
    if (queryString) {
        queryString = "?".concat(queryString);
    }
    return "/fbe-login".concat(queryString);
};
export var generateFbeLoginRedirectObject = function (locationQuery) {
    return {
        pathname: '/fbe-login-redirect',
        query: __assign({}, locationQuery),
    };
};
export var buildInstagramRedirectUrl = function (queryParams, extras) {
    var redirectUrl = queryParams.redirect_uri;
    if (!redirectUrl) {
        throw new Error('Redirect URI is required');
    }
    var redirectUrlParams = new URLSearchParams(__assign(__assign({}, omit(queryParams, ['redirect_uri'])), { extras: JSON.stringify(extras) }));
    return "".concat(redirectUrl, "&").concat(redirectUrlParams.toString());
};
